import axios from "axios";

export default {
	async store(payload) {
		return await axios.post("/profile/billing_details", payload);
	},
	async update(id, payload) {
		return await axios.put("/profile/billing_details/" + id, payload);
	},
	async delete(id) {
		return await axios.delete("/profile/billing_details/" + id);
	},

};